import { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import NavBar from "./components/NavBar/NavBar";
import Lists from "./pages/Lists";
import List from "./pages/List";
import Signup from "./pages/auth/Signup";
import Login from "./pages/auth/Login";
import Account from "./pages/auth/AccountSettings";
import PublicListView from "./pages/PublicListView";
import Footer from "./components/Footer/Footer";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import ListJoin from "./pages/ListJoin";

export default function App() {
  const [lists, setLists] = useState(() => {
    const saved = localStorage.getItem("giftLists");
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem("giftLists", JSON.stringify(lists));
  }, [lists]);

  return (
    <Router>
      <div className="min-h-screen flex flex-col bg-background">
        <NavBar />

        <div className="flex-grow">
          <Routes>
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Lists />
                </ProtectedRoute>
              }
            />

            {/* Single List page */}
            <Route
              path="/lists"
              element={
                <ProtectedRoute>
                  <Lists lists={lists} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lists/:listId/*"
              element={
                <ProtectedRoute>
                  <List lists={lists} setLists={setLists} />
                </ProtectedRoute>
              }
            />

            {/* Account */}
            <Route
              path="/account"
              element={
                <ProtectedRoute>
                  <Account />
                </ProtectedRoute>
              }
            />

            {/* Join List (from Invite) */}
            <Route path="/list-join" element={<ListJoin />} />

            {/* Public View of List */}
            <Route path="/public-list/:listId" element={<PublicListView />} />

            {/* Auth */}
            <Route path="/signup" element={<Signup />} />
            <Route path="/login" element={<Login />} />

            {/* Additional Pages */}
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}
